import React from "react"
import Layout from "../components/layout"

import HomePage from "../components/HomePage"

export default function Home() {
  return (
      <Layout>
        <HomePage />
      </Layout>
  )
}
